export const getCommentsByParentId = (state, parentId) =>
  state.comments.commentsByParentId[parentId] || [];

export const getCommentsCount = (state, parentId) =>
  state.comments.commentsByParentId[parentId]?.length || 0;
